import React from "react";
import * as Icons from "@ant-design/icons";

/**
 * Drop-in replacement for `Icon` from the archived `@ant-design/compatible`
 * package. Maps antd v3 string `type` props to the corresponding icon
 * component from `@ant-design/icons`.
 *
 * Prefer importing the specific `*Outlined` icon directly in new code.
 */

// antd v3 names that don't follow the kebab→PascalCase + "Outlined" rule.
const ALIASES: Record<string, string> = {
  "appstore-o": "AppstoreOutlined",
};

const toPascal = (s: string): string =>
  s.replace(/(^|-)([a-z])/g, (_, __, c: string) => c.toUpperCase());

export interface LegacyIconProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  type: string;
  spin?: boolean;
  rotate?: number;
  twoToneColor?: string;
  [key: string]: any;
}

export const Icon: React.FC<LegacyIconProps> = ({ type, ...rest }) => {
  const name = ALIASES[type] ?? `${toPascal(type)}Outlined`;
  const Cmp = (Icons as any)[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(
        `[LegacyIcon] No @ant-design/icons component found for type="${type}" (looked for "${name}")`,
      );
    }
    return null;
  }
  return <Cmp {...rest} />;
};

export default Icon;
